// extracted by mini-css-extract-plugin
export var scrollArea = "_qh-0";